import {useDebugValue} from 'react';

import {undef} from '../../../utils/undef';

import {useTranslations} from './useTranslations';

const defaultDatesTranslations = {
    startDateLabel: 'Check-in',
    endDateLabel: 'Check-out',
    startDateText: undef,
    endDateText: undef,
    directionsMessage: 'Check-in date expanded. Choose a date from the table below. Tab into the table and use the arrow keys for navigation.',
    modalTitleStartDateMessage: 'Select your check-in date',
    modalTitleEndDateMessage: 'Select your check-out date',
    clearButtonLabel: 'Clear',
    closeButtonLabel: 'Close',
    continueButtonLabel: 'Continue',
    // calendarYearLabel: '',
    // calendarMonthLabels: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
    // calendarShortMonthLabels: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
    // calendarDayLabels: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
    // calendarShortDayLabels: ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'],
    prevMonthButtonLabel: 'Previous month',
    nextMonthButtonLabel: 'Next month',
    dateUnavailableMessage: '{0} is unavailable.',
    datesClearedMessage: 'Dates cleared.',
    selectDateHintMessage: 'Choose check-out date',
    startDateClearedMessage: 'Check-in date cleared.',
    startDateInvalidMessage: '{0} is not a valid check-in date.',
    startDateSelectedMessage: '{0} is selected as your check-in date.',
    endDateClearedMessage: 'Check-out date cleared.',
    endDateInvalidMessage: '{0} is not a valid check-out date.',
    endDateSelectedMessage: '{0} is selected as your check-out date.'
};

function useDatesTranslations(props) {
    const {
        datesTranslations: propsDatesTranslations
    } = props;

    const {
        translations: datesTranslations
    } = useTranslations(defaultDatesTranslations, propsDatesTranslations);

    const result = {
        datesTranslations
    };

    useDebugValue(result);

    return result;
}

export {useDatesTranslations};
